<mat-form-field appearance="outline" fxFlex="100%">
  <mat-label>Observation de la boite</mat-label>
  <textarea type="text" rows="3" matInput [formControl]="observation"></textarea>
  <mat-hint *ngIf="autoSaveDone">Vos modifications ont été sauvegardées</mat-hint>
  <mat-hint *ngIf="!autoSaveDone">Modifications en cours</mat-hint>
</mat-form-field>
